import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServiceRequestService } from '@shared/services/service-request.service';
import * as events from 'events';
import { data } from 'jquery';

@Component({
    selector: 'cbm-item',
    templateUrl: './cbm-item.component.html',
    styleUrls: ['./cbm-item.component.scss'],
    standalone: false
})
export class CbmItemComponent implements OnInit {
  @Input() selectionOrder: number = 0;
  @Input() selected: boolean = false;
  @Input() recommended: boolean = false;
  @Input() pcab: string = 'A';
  @Input() name: string = 'CBM NAME';
  @Input() tags: string[] = [
    'Most Awaited',
    'Excellent Customer Service',
    'Quick Response Time',
    'Good Quality of Work',
  ];
  @Input() uuid: string = '';
  @Input() city: string = '';

  @Output() itemClick: EventEmitter<any> = new EventEmitter();
  @Output() onViewDetail: EventEmitter<any> = new EventEmitter();

  feedbacks: any[] = [];
  rating: number = 0;

  constructor(private serviceRequest: ServiceRequestService) {}

  ngOnInit() {
    this.getDetails();
  }
  clicked() {
    this.itemClick.emit();
  }
  viewDetail($event) {
    $event.stopPropagation();
    this.onViewDetail.emit();
  }

  getDetails() {
    this.serviceRequest
      .getContractorDetails(this.uuid, this.city)
      .subscribe(data => {
        this.feedbacks = data['body']['feedback'];
        this.rating = this.getRatingValue(data['body']['contractor']['rating']);
      });
  }

  getRatingValue(rating: string | number): number {
    if (typeof rating === 'string') {
      rating = parseFloat(rating);
    }
    if (!rating) return 0
    return parseFloat(rating?.toFixed(1));
  }
}
